export const en = {
    fatalError: 'An error occurred while copying. Try again later'
};
